import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './init.js'
import 'lib-flexible/flexible'
//1rem = 75px
Vue.config.productionTip = false
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
